// https://stackoverflow.com/questions/17242144/javascript-convert-hsb-hsv-color-to-rgb-accurately
export type Color = {
  r: number
  g: number
  b: number
  a: number
}

export const hsvToRgb = ({ h, s, v }: { h: number; s: number; v: number }) => {
  const i = Math.floor(h * 6)
  const f = h * 6 - i
  const p = v * (1 - s)
  const q = v * (1 - f * s)
  const t = v * (1 - (1 - f) * s)
  let r = 0
  let g = 0
  let b = 0
  switch (i % 6) {
    case 0:
      r = v
      g = t
      b = p
      break
    case 1:
      r = q
      g = v
      b = p
      break
    case 2:
      r = p
      g = v
      b = t
      break
    case 3:
      r = p
      g = q
      b = v
      break
    case 4:
      r = t
      g = p
      b = v
      break
    case 5:
      r = v
      g = p
      b = q
      break
  }
  return {
    r: Math.floor(r * 256),
    g: Math.floor(g * 256),
    b: Math.floor(b * 256),
    a: 1,
  }
}

export const prettyColor = (random: number): Color => {
  const goldenRatioConjugate = 0.618
  return hsvToRgb({
    h: (random * goldenRatioConjugate) % 1,
    s: 0.3,
    v: 0.99,
  })
}

export const toCSS = ({ r, g, b, a }: Color): string => {
  return `rgba(${r},${g},${b},${a})`
}

const eotf = (colorComponent: number) =>
  colorComponent <= 0.04045
    ? colorComponent / 12.92
    : Math.pow((colorComponent + 0.055) / 1.055, 2.4)

const saturate = (v: number) => (v <= 0 ? 0 : v >= 1 ? 1 : v)

export const luminance = ({ r, g, b }: Color) =>
  saturate(0.2126 * eotf(r) + 0.7152 * eotf(g) + 0.0722 * eotf(b))

export const textColorFor = (backgroundColor: Color): Color =>
  luminance(backgroundColor) > 0.729
    ? { r: 0, g: 0, b: 0, a: 0.87 }
    : { r: 1, g: 1, b: 1, a: 0.87 }
